export const getSurveyCookie = (country) => {
    switch (country) {
        case 'ES':
            return { zohoSurveyCode: '2mBaHi', zohoSurveyId: '103946000002476802' };
        case 'PT':
            return { zohoSurveyCode: 'jHBaDR', zohoSurveyId: '103946000002478293' };
        case 'IT':
            return { zohoSurveyCode: 'vSBaRe', zohoSurveyId: '103946000002475339' };
        case 'FR':
        default:
            return { zohoSurveyCode: '1dBa7i', zohoSurveyId: '103946000002473926' };
    }
};
